import { render, staticRenderFns } from "./Mensalidade.vue?vue&type=template&id=3a46672e&"
import script from "./Mensalidade.vue?vue&type=script&lang=js&"
export * from "./Mensalidade.vue?vue&type=script&lang=js&"
import style0 from "./Mensalidade.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports